import { NativeSelect } from '@/components/ui/select';

export interface LetterOption {
  code: string;
  label: string;
}

export function LetterSelect({
  letter,
  options,
  onPick,
}: {
  letter?: string;
  options: LetterOption[];
  onPick: (patch: { letter: string; letterLabel: string }) => void;
}) {
  return (
    <NativeSelect
      aria-label="Lettre"
      value={letter ?? ''}
      onChange={(e) => {
        const picked = options.find((o) => o.code === e.target.value);
        if (picked) onPick({ letter: picked.code, letterLabel: picked.label });
      }}
      className="h-8 text-[13px] w-auto"
    >
      <option value="" disabled>—</option>
      {options.map((o) => (
        <option key={o.code} value={o.code}>{o.code} — {o.label}</option>
      ))}
    </NativeSelect>
  );
}
